/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { MotifErrorMessage } from "@ey-xd/motif-react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router";
import {
  AUTO_PROVISION,
  AUTO_PROVISION_PLACEHOLDER,
  COST_INTERVAL,
  COST_INTERVAL_PLACEHOLDER,
  COMMERCIAL_PLACEHOLDER,
  COMMERCIAL_STATUS,
  COST,
  COST_CATEGORY,
  COST_CATEGORY_PLACEHOLDER,
  COST_MACRO_CATEGORY,
  COST_MACRO_CATEGORY_PLACEHOLDER,
  EMPIRE_CODE_PLACEHOLDER,
  MINIMUM_SELECTABLE_INCREMENT,
  RETURNABLE,
  RETURNABLE_PLACEHOLDER,
  SKU_LONG_DESCRIPTION,
  SKU_NAME,
  SKU_RELATION,
  SKU_RELATION_PLACEHOLDER,
  COST_METRIC,
  COST_METRIC_PLACEHOLDER,
  BILLING_TYPE_STATUS,
  ORDER_ACKNOWLEDGEMENT,
  NSR,
  INDEXATION,
  INDEXATION_PLACEHOLDER,
} from "../../../CreateSku/Constants";

import { getEditableFields } from "../../Helper";
import { AppDispatch, RootState } from "../../../../store";
import { fetchSkuListAllData } from "../../../../store/slices/CTDBSkuListAllSlice";
import { fetchSkuConfigData } from "../../../../store/slices/CTDBSkuConfigSlice";
import { getSkuDetails } from "../../../../store/slices/CTDBCreateSkuSlice";
import {
  isHTML,
  isStringHavingSpecialChars,
  ltrimString,
} from "../../../../utils/Validator";

import Loader from "../../../../components/Loader";
import InputBox from "../../../../components/Form/InputBox/InputBox";
import SelectBox from "../../../../components/Form/SelectBox/SelectBox";
import {
  formatUSDWithCommas,
  sortOptions,
  sanitizeHTMLSpace,
  isDatePassed,
} from "../../../../utils/common";
import {
  PROVISIONING_TEAM,
  GLOBAL_RISK_MANAGER,
  LOCAL_RISK_MANAGER,
  PRODUCT_APPROVER,
  VALIDATION_ERROR_MESSAGES,
  CONSUMPTION_MANAGER,
  MAX_LENGTH_SKU_NAME,
} from "../../../../Constant";
import { RichTextEditor } from "../../../../components/Form/RichTextEditor/RichTextEditor";
import MultiSelect from "../../../../components/MultiSelect/MultiSelect";
import CostUpdateRequest from "../CostUpdateRequest/CostUpdateRequest";
import { EmailNotificationState } from "../../ProductDataType";
import { convertDateStringtoDate } from "../../../../utils/dateFunction";
import UserSearchSelect from "../../../../components/UserSearchSelect";

interface ProxyOwner {
  Name: string;
  Email: string;
}

interface CreateSkuProps {
  selectedSku?: string;
  formFields: any;
  setFormFields: React.Dispatch<any>;
  error: any;
  setError: React.Dispatch<React.SetStateAction<any>>;
  validateFields: (
    name: string,
    value: string | string[],
  ) => boolean | undefined;
  errorInitail: any;
  localRiskMng: ProxyOwner[] | null;
  setLocalRiskMng: React.Dispatch<React.SetStateAction<ProxyOwner[] | null>>;
  globalRiskMng: ProxyOwner[] | null;
  setGlobalRiskMng: React.Dispatch<React.SetStateAction<ProxyOwner[] | null>>;
  productApproverList: ProxyOwner[] | null;
  setProductApproverList: React.Dispatch<
    React.SetStateAction<ProxyOwner[] | null>
  >;
  deploymentApproverList: ProxyOwner[] | null;
  setDeploymentApproverList: React.Dispatch<
    React.SetStateAction<ProxyOwner[] | null>
  >;
  consumptionManagerList: ProxyOwner[] | null;
  setConsumptionManagerList: React.Dispatch<
    React.SetStateAction<ProxyOwner[] | [] | null>
  >;
  setDisableProductDetails: React.Dispatch<React.SetStateAction<boolean>>;
  emailNotification: EmailNotificationState;
  setEmailNotification: React.Dispatch<
    React.SetStateAction<EmailNotificationState>
  >;
}

export default function CreateSku({
  selectedSku,
  formFields,
  setFormFields,
  error,
  setError,
  validateFields,
  errorInitail,
  localRiskMng,
  setLocalRiskMng,
  globalRiskMng,
  setGlobalRiskMng,
  productApproverList,
  setProductApproverList,
  deploymentApproverList,
  setDeploymentApproverList,
  consumptionManagerList,
  setConsumptionManagerList,
  setDisableProductDetails,
  emailNotification,
  setEmailNotification,
}: CreateSkuProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [getSKUData, setGetSkuData] = useState<null | any>(null);
  const [disableAll, setDisableAll] = useState(true);
  const [disableCostUpdate, setDisableCostUpdate] = useState(false);
  const [hideCostUpdate, setHideCostUpdate] = useState(false);
  const param = useParams();
  const [searchParams] = useSearchParams();
  const searchQueryRequest = searchParams.get("RequestType");
  const searchQuerySource = searchParams.get("Source");

  const dispatch = useDispatch<AppDispatch>();

  const isconfigLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.isLoading,
  );
  const configData = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.data,
  );
  const configErrorAPi = useSelector(
    (state: RootState) => state.CTDBSkuConfigSlice.error,
  );

  const isSkuListLoadingAPi = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.isLoading,
  );
  const skuListData = useSelector(
    (state: RootState) => state.CTDBSkuListAllSlice.data,
  );

  const getSKUIsLoadingAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.isLoadingDetails,
  );

  const getSKUErrorAPi = useSelector(
    (state: RootState) => state.CTDBCreateSkuSlice.errorDetails,
  );

  const currentSku = selectedSku;

  useEffect(() => {
    dispatch(
      fetchSkuListAllData({
        search: "",
        productId: param.id || "", // Replace with actual product ID
        page: 1,
        record: 1000,
        sortOrder: "desc",
        sortColumn: "SkuId",
        exclude: "AutoTransact",
        skuRelation: true,
      }),
    );
  }, [dispatch, param.id]);

  useEffect(() => {
    if (param.id !== undefined && param.id !== null && configData === null) {
      dispatch(fetchSkuConfigData());
    }
  }, [param.id, configData]);

  useEffect(() => {
    if (param.id !== undefined && param.id !== null) {
      if (currentSku && currentSku !== "") {
        async function fetchSkuDetails() {
          const skuDetailsFetch = await dispatch(
            getSkuDetails({
              ProductId: param.id,
              SkuId: currentSku,
            }),
          );
          setError(errorInitail);
          setGetSkuData(skuDetailsFetch.payload.Data[0]);
          setDisableAll(
            skuDetailsFetch.payload.Data[0]?.UpdateStatusCd
              ? skuDetailsFetch.payload.Data[0].UpdateStatusCd ===
                "skuupdate_submitted"
                ? true
                : false
              : false,
          );
          setDisableProductDetails(
            skuDetailsFetch.payload.Data[0]?.UpdateStatusCd
              ? skuDetailsFetch.payload.Data[0].UpdateStatusCd ===
                "skuupdate_submitted"
                ? true
                : false
              : false,
          );
        }
        fetchSkuDetails();
      }
    }
  }, [currentSku, param.id, dispatch]);

  const resetEmailNotification = () => {
    setEmailNotification({
      ...emailNotification,
      show: false,
      message: "",
      supportingText: "",
      actionRedirectUrl: "",
      actionRedirectLabel: "",
      scrollToSection: "",
    });
  };

  useEffect(() => {
    if (getSKUData !== null && getSKUData !== undefined) {
      if (
        searchQueryRequest === "CostUpdate" &&
        searchQuerySource === "Email"
      ) {
        const { CostReviewOutcome } = getSKUData;
        const { ReviewCompleted, Status, ReviewedBy } = CostReviewOutcome || {};
        const status = Status?.toLowerCase();
        if (ReviewCompleted && status !== "pending") {
          setEmailNotification({
            ...emailNotification,
            show: true,
            message: `SKU cost update request ${status === "cancelled" ? "" : "already"} ${status}`,
            supportingText: (
              <span>
                The SKU cost update request for SKU{" "}
                <b>
                  {getSKUData.Name} - {getSKUData.SkuId}
                </b>{" "}
                was {status === "cancelled" ? "" : "already"} {status} by{" "}
                <b>{ReviewedBy?.Name}</b>.
              </span>
            ),
            actionRedirectUrl: "/ct/bmo",
            actionRedirectLabel: "Review pending approvals",
          });
          setDisableAll(true);
          setDisableProductDetails(true);
          if (status === "cancelled") {
            setHideCostUpdate(true);
          } else {
            setDisableCostUpdate(true);
          }
        }
      } else if (
        searchQueryRequest === "NewSku" &&
        searchQuerySource === "Email"
      ) {
        setHideCostUpdate(true);
        const { SkuReviewOutcome } = getSKUData;
        const { ReviewCompleted, Status, ReviewedBy } = SkuReviewOutcome || {};
        const status = Status?.toLowerCase();
        if (ReviewCompleted && status !== "pending") {
          setDisableProductDetails(true);
          setEmailNotification({
            ...emailNotification,
            show: true,
            message: `New SKU request already ${status}`,
            supportingText: (
              <span>
                The new SKU request for SKU{" "}
                <b>
                  {getSKUData.Name} - {getSKUData.SkuId}
                </b>{" "}
                was already {status} by <b>{ReviewedBy?.Name}</b>.
              </span>
            ),
            actionRedirectUrl: "/ct/bmo",
            actionRedirectLabel: "Review pending approvals",
          });
          setDisableAll(true);
          if (status === "rejected") {
            setHideCostUpdate(true);
          }
        }
      } else {
        resetEmailNotification();
      }
      const publishDateVal = getSKUData?.UpdatePublishDtm ?? "";
      const publishDateOrg = convertDateStringtoDate(publishDateVal);
      const costReviewStatus =
        getSKUData?.CostReviewOutcome?.Status?.toLowerCase();
      if (isDatePassed(publishDateOrg) && costReviewStatus !== "rejected") {
        setEmailNotification({
          ...emailNotification,
          show: true,
          message: `SKU cost update request expired`,
          supportingText: (
            <span>
              The SKU cost update request for SKU{" "}
              <b>
                {getSKUData.Name} - {getSKUData.SkuId}
              </b>{" "}
              has expired. Review the details and reject the SKU so a new
              request can be submitted.
            </span>
          ),
          scrollToSection: "cost-update-section",
          actionRedirectLabel: "Review request",
        });
      }
    }
  }, [getSKUData]);

  const {
    skuShortDescription: skuShortDescriptionError,
    skuLongDescription: skuLongDescriptionError,
    costCategory: costCategoryError,
    chargingIncrement: chargingIncrementError,
    returnable: returnableError,
    costMacroCategory: costMacroCategoryError,
    minimumSelectableIncrement: minimumSelectableIncrementError,
    cost: costError,
    skuRelation: skuRelationError,
    autoProvision: autoProvisionError,
    commercialStatus: commercialStatusError,
    billingType: billingTypeError,
    costMetric: costMetricError,
    CostMetricNSR: CostMetricNSRError,
    Indexation: IndexationError,
    deploymentApprover: deploymentApproverError,
  } = error;

  const handleChangeSku = (selectedValue: {
    target: { name: string; value: string | string[] };
  }) => {
    const handleSingleChange = (event: {
      target: { name: string; value: string | string[] };
    }) => {
      const { name, value } = event.target;
      const val = Array.isArray(value)
        ? value.filter(
            (item: string) =>
              typeof item === "string" &&
              item !== SKU_RELATION_PLACEHOLDER &&
              item !== "",
          )
        : value;

      setFormFields(() => {
        return {
          ...formFields,
          [name]: val,
        };
      });
    };

    handleSingleChange(selectedValue);
  };

  const handleDeploymentApproverChange = (type: string) => {
    const isError =
      type === "remove" &&
      isNotAutoProvisioned &&
      deploymentApproverList?.length === 1;
    setError((prevState: any) => ({
      ...prevState,
      deploymentApprover: {
        isError,
        message: "",
        validation: [isError ? "required" : ""],
        label: PROVISIONING_TEAM,
      },
    }));
  };

  // const handleValidateMinimumSelectableIncrement = (
  //   interval: "month" | "week",
  //   value: number
  // ) => {
  //   if (["month", "week"].includes(interval) && value) {
  //     const isValidIncrement = validateMinimumSelectableIncrement(
  //       Number(value),
  //       interval
  //     );
  //     setError((prevState: typeof errorInitail) => ({
  //       ...prevState,
  //       minimumSelectableIncrement: {
  //         isError: !isValidIncrement,
  //         message: isValidIncrement
  //           ? ""
  //           : getMinimumSelectableIncrementErrorMessage(interval),
  //         validation: ["required", "isNumber", "isInteger", "notZero"],
  //       },
  //     }));
  //   }
  // };

  const getSlicedSkuName = (name: string, value: string | string[]) => {
    if (name === "skuShortDescription" && value.length > MAX_LENGTH_SKU_NAME) {
      const slicedValue = value.slice(0, MAX_LENGTH_SKU_NAME);
      setFormFields(() => {
        return {
          ...formFields,
          [name]: slicedValue,
        };
      });
    }
  };

  const handleChange = (selectedValue: {
    target: { name: string; value: string | string[] };
  }) => {
    const handleSingleChange = (event: {
      target: { name: string; value: string | string[] };
    }) => {
      //const name = event.target.name;
      //const value = event.target.value;
      const { name, value } = event.target;
      let val = value;
      if (!Array.isArray(value)) {
        val = ltrimString(value);

        if (isStringHavingSpecialChars(val) && !isHTML(val)) {
          return;
        }

        if (!validateFields(name, val)) {
          //return false;
        }
      } else {
        val = value.map((item) => ltrimString(item));
        if (!validateFields(name, val)) {
          //return false;
        }
      }

      if (name === "autoProvision") {
        const isError = value == "0" && deploymentApproverList?.length === 0;
        setError((prevState: any) => ({
          ...prevState,
          deploymentApprover: {
            isError,
            message: "",
            validation: isError ? ["required"] : [""],
            label: PROVISIONING_TEAM,
          },
        }));
      }

      if (
        (name === "CostMetricNSR" ||
          name === "cost" ||
          name === "Indexation") &&
        !Array.isArray(val)
      ) {
        val = val.replace(/[^0-9.]/g, "");
        val = val.replace(/(\..*)\./g, "$1");
        if (formatUSDWithCommas(val).length > 9) {
          if (val.endsWith(".")) {
            val = val.slice(0, -1);
          } else if (val.includes(".")) {
            const [intPart, decPart] = val.split(".");
            val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
          } else {
            val = val.slice(0, 8);
          }
        }

        if (val && val.includes(".")) {
          const [intPart, decPart] = val.split(".");
          val = intPart.slice(0, 6) + "." + decPart.slice(0, 2);
        }
        if (name === "Indexation") {
          const numericVal = parseFloat(val);

          setFormFields(() => ({
            ...formFields,
            [name]: numericVal,
          }));
        }
      }
      if (name === "costCategory") {
        setFormFields(() => ({
          ...formFields,
          [name]: val,
          costMetric: "",
          chargingIncrement: "",
        }));
        setError((prev: any) => ({
          ...prev,
          costMetric: {
            ...prev.costMetric,
            message: VALIDATION_ERROR_MESSAGES.REQUIRED,
            isError: true,
          },
          chargingIncrement: {
            ...prev.chargingIncrement,
            message: VALIDATION_ERROR_MESSAGES.REQUIRED,
            isError: true,
          },
        }));
      } else {
        setFormFields(() => {
          return {
            ...formFields,
            [name]: val,
          };
        });
      }
      // if (name === "minimumSelectableIncrement" && value) {
      //   handleValidateMinimumSelectableIncrement(
      //     formFields.chargingIncrement,
      //     Number(value)
      //   );
      // }
      if (name === "chargingIncrement") {
        // handleValidateMinimumSelectableIncrement(
        //   value as "month" | "week",
        //   Number(formFields.minimumSelectableIncrement)
        // );
        setFormFields(() => {
          if (formFields.chargingIncrement === "onetime" && val !== "onetime") {
            setError((prev: { minimumSelectableIncrement: any }) => ({
              ...prev,
              minimumSelectableIncrement: {
                ...prev.minimumSelectableIncrement,
                isError: true,
                message: VALIDATION_ERROR_MESSAGES.REQUIRED,
              },
            }));
            return {
              ...formFields,
              [name]: val,
              minimumSelectableIncrement: "",
            };
          }
          if (val === "autotransact") {
            setError((prev: any) => ({
              ...prev,
              minimumSelectableIncrement: {
                ...prev.minimumSelectableIncrement,
                isError: false,
                message: "",
              },
              costCategory: {
                ...prev.costCategory,
                isError: false,
                message: "",
              },
              deploymentApprover: {
                ...prev.deploymentApprover,
                isError: false,
                message: "",
                validation: [""],
              },
            }));
            return {
              ...formFields,
              [name]: val,
              costCategory: "Variable",
              minimumSelectableIncrement: "1",
              skuRelation: [],
              autoProvision: "1",
              returnable: "0",
            };
          }
          if (val === "onetime") {
            setError(
              (prev: {
                minimumSelectableIncrement: any;
                costCategory: any;
              }) => ({
                ...prev,
                minimumSelectableIncrement: {
                  ...prev.minimumSelectableIncrement,
                  isError: false,
                  message: "",
                },
                costCategory: {
                  ...prev.costCategory,
                  isError: false,
                  message: "",
                },
              }),
            );
            return {
              ...formFields,
              [name]: val,
              costCategory: "Fixed",
              minimumSelectableIncrement: "1",
            };
          }
          return {
            ...formFields,
            [name]: val,
          };
        });
      }
      if (
        name === "skuShortDescription" &&
        value.length > MAX_LENGTH_SKU_NAME
      ) {
        getSlicedSkuName(name, value);
      }
    };

    handleSingleChange(selectedValue);
  };

  const validateDecimalValue = (amt: any) => {
    if (amt === null || amt === undefined) {
      return "";
    }

    amt = String(amt);
    if (
      formatUSDWithCommas(amt).length > 0 &&
      formatUSDWithCommas(amt).length < 9
    ) {
      if (!amt.includes(".")) {
        // If no dot, append .00
        amt = amt + ".00";
      } else {
        const [intPart, decPart] = amt.split(".");
        const newInt = intPart || "0";
        const newDec = decPart.padEnd(2, "0").slice(0, 2); // Fill zeros if needed
        amt = newInt + "." + newDec;
      }
    }
    return amt;
  };

  const handleBlur = (event: { target: { name: string; value: string } }) => {
    const { name, value } = event.target;
    let val = value.replace(/[^0-9.]/g, ""); // Allow only digits and dot
    val = val.replace(/(\..*)\./g, "$1"); // Only one dot

    val = validateDecimalValue(val);

    setFormFields(() => {
      return {
        ...formFields,
        [name]: val,
      };
    });
  };

  const {
    skuShortDescription,
    skuLongDescription,
    costCategory,
    chargingIncrement,
    returnable,
    costMacroCategory,
    minimumSelectableIncrement,
    cost,
    skuRelation,
    autoProvision,
    commercialStatus,
    costMetric,
    billingType,
    CostMetricNSR,
    Indexation,
  } = formFields;

  const CostCategoryTypeOptions: { label: string; value: string }[] = [
    {
      label: COST_CATEGORY_PLACEHOLDER,
      value: "",
    },
  ];

  const CostMetricOptions: { label: string; value: string }[] = [
    {
      label: COST_METRIC_PLACEHOLDER,
      value: "",
    },
  ];
  let CommercialStatusOptions: { label: string; value: string }[] = [
    {
      label: COMMERCIAL_PLACEHOLDER,
      value: "",
    },
  ];
  let BillingTypeOptions: { label: string; value: string }[] = [];
  let CostMacroCategoryOptions: { label: string; value: string }[] = [];
  let ChargingIncrementOptions: { label: string; value: string }[] = [];
  let skuRelationOption: { label: string; value: string }[] = [];
  if (configData === null) {
    console.log("configData is null");
  } else {
    const {
      CostCategory,
      CommercialStatus,
      CostMacroCategory,
      ChargingIncrement,
    } = configData;

    const uniqueCostCategory: string[] = [];
    CostCategory?.forEach(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      (item: {
        Name: string;
        CostMetricType: string;
        CostMetricCd: string;
        CostMetric: string;
      }) => {
        if (costCategory === "" || costCategory === item.CostMetricType) {
          CostMetricOptions.push({
            label: item.CostMetric,
            value: item.CostMetricCd,
          });
        }
        if (uniqueCostCategory.includes(item.CostMetricType) === false) {
          uniqueCostCategory.push(item.CostMetricType);
          CostCategoryTypeOptions.push({
            label: item.CostMetricType,
            value: item.CostMetricType,
          });
        }
      },
    );
    const CommercialStatusFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "sku",
    );

    CommercialStatusOptions = CommercialStatusFilter?.map(
      (item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
        disabled: item.Name === "Draft" && getSKUData?.StatusCd !== "Draft",
      }),
    );
    const billingTypeFilter = CommercialStatus?.filter(
      (item: { Name: string; StatusCd: string; StatusType: string }) =>
        item.StatusType === "skubill",
    );

    BillingTypeOptions =
      billingTypeFilter?.map((item: { Name: string; StatusCd: string }) => ({
        label: item.Name,
        value: item.StatusCd,
      })) || [];

    CostMacroCategoryOptions = CostMacroCategory?.map(
      (item: { Name: string; CostMacroCategoryCd: string }) => ({
        label: item.Name,
        value: item.CostMacroCategoryCd,
      }),
    );
    ChargingIncrementOptions = ChargingIncrement?.filter(
      (item: { CostIntervalCd: string }) => {
        if (costCategory === "Variable") {
          return item.CostIntervalCd !== "onetime";
        }
        if (costCategory === "Fixed") {
          // Hide "autotransact"
          return item.CostIntervalCd !== "autotransact";
        }
        return true;
      },
    ).map((item: { Name: string; CostIntervalCd: string }) => ({
      label: item.Name,
      value: item.CostIntervalCd,
    }));
    const skuListDataParentOnly = skuListData?.Result?.filter((items: any) => {
      return (
        items.SkuRelation.length === 0 &&
        items.SkuId !== currentSku &&
        items.StatusCd === "sku_active"
      );
    });
    if (skuListDataParentOnly && skuListDataParentOnly.length > 0) {
      skuRelationOption = skuListDataParentOnly?.map(
        (item: { Name: string; SkuId: string }) => ({
          label: item.Name,
          value: item.SkuId,
        }),
      );
    }
  }
  useEffect(() => {
    if (getSKUData && getSKUData !== null && configData !== null) {
      const skuRelationSelected = Array.isArray(getSKUData?.SkuRelation)
        ? (getSKUData.SkuRelation as unknown as { SkuId: string }[]).map(
            (item) => item.SkuId,
          )
        : [];

      const commercialStatus = CommercialStatusOptions?.find(
        (item) => item.label === getSKUData?.StatusCd,
      );
      const billingType = BillingTypeOptions?.find(
        (item) => item.label === getSKUData?.BillingTypeCd,
      );
      const selectedCostCategory = configData?.CostCategory?.find(
        (item: {
          CostMetricType: string;
          CostMetricCd: string;
          Name: string;
        }) => item.CostMetricCd === getSKUData?.CostMetricCd,
      );
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setGlobalRiskMng(getSKUData?.GlobalRiskMgr);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setLocalRiskMng(getSKUData?.LocalRiskMgr);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setProductApproverList(getSKUData?.ProductApprover);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      setDeploymentApproverList(getSKUData?.DeploymentApprover);

      setConsumptionManagerList(getSKUData?.ConsumptionMgr);
      setFormFields(() => {
        if (
          CostMacroCategoryOptions.length ==
          (getSKUData?.CostMacroCategoryCd).length
        ) {
          (getSKUData?.CostMacroCategoryCd).push("all");
        }
        return {
          ...formFields,
          skuShortDescription: getSKUData?.Name,
          skuLongDescription: getSKUData?.Description,
          costCategory: selectedCostCategory?.CostMetricType,
          chargingIncrement: getSKUData?.CostIntervalCd,
          returnable: getSKUData?.IsReturnable ? "1" : "0",
          costMacroCategory: getSKUData?.CostMacroCategoryCd,
          minimumSelectableIncrement: getSKUData?.CostIntervalMin,
          cost: validateDecimalValue(getSKUData?.CostMetricCost || 0),
          skuRelation: skuRelationSelected,
          autoProvision: getSKUData?.IsAutoProvisioned ? "1" : "0",
          commercialStatus: commercialStatus?.value,
          costMetric: selectedCostCategory?.CostMetricCd || "",
          CostMetricNSR: validateDecimalValue(getSKUData?.CostMetricNSR),
          Indexation: validateDecimalValue(getSKUData?.Indexation),
          billingType: billingType?.value || "",
          skuNumber: getSKUData?.SkuId,
          productId: getSKUData?.ProductId,
          ProductSkuNum: getSKUData?.ProductSkuNum,
        };
      });
    }
  }, [getSKUData, configData]);

  const editableFields = getEditableFields(commercialStatus);

  const isNotAutoProvisioned = autoProvision === "0";

  if (isconfigLoadingAPi || isSkuListLoadingAPi || getSKUIsLoadingAPi) {
    return <Loader />;
  }
  if (configErrorAPi || getSKUErrorAPi) {
    return <div className="error">Error fetching data</div>;
  }
  if (!configData) {
    return <div className="error">No data available</div>;
  }
  return (
    <div className="create-sku-modal formSku">
      <div className="motif-row heading">
        <div className="motif-col-lg-12">
          <div className="title">SKU Details</div>
        </div>
      </div>
      <div className="motif-row form-item-row single-row">
        <div className="motif-col-lg-2  form-item">
          <div className="label">
            {EMPIRE_CODE_PLACEHOLDER}
            <span className="required">*</span>
          </div>
        </div>
        <div className="motif-col-lg-5  form-item skuNumbertext">
          {`${currentSku}`}
        </div>
      </div>
      <div className="motif-row form-item-row single-row">
        <div className="motif-col-lg-2  form-item">
          <div className="label">
            {SKU_NAME}
            <span className="required">*</span>
          </div>
        </div>
        <div className="motif-col-lg-10  form-item">
          <div className="value">
            <div className="inputField">
              <InputBox
                ariaLabel=""
                label=""
                onChange={handleChange}
                name={"skuShortDescription"}
                value={skuShortDescription}
                placeholder={SKU_NAME}
                error={skuShortDescriptionError}
                readonly={
                  disableAll || !editableFields.includes("skuShortDescription")
                }
                hideClearButton={true}
              />
              <MotifErrorMessage
                aria-live="assertive"
                role="alert"
                id="aria-error-example"
              >
                {skuShortDescriptionError
                  ? skuShortDescriptionError.message
                  : ""}
              </MotifErrorMessage>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row single-row">
        <div className="motif-col-lg-2  form-item">
          <div className="label">
            {SKU_LONG_DESCRIPTION}
            <span className="required">*</span>
          </div>
        </div>
        <div className="motif-col-lg-10  form-item">
          <div className="value">
            <div className="inputField">
              <RichTextEditor
                name={"skuLongDescription"}
                readOnly={
                  disableAll || !editableFields.includes("skuLongDescription")
                }
                value={
                  disableAll || !editableFields.includes("skuLongDescription")
                    ? sanitizeHTMLSpace(skuLongDescription)
                    : skuLongDescription
                }
                placeholder={SKU_LONG_DESCRIPTION}
                handleChange={handleChange}
              />
              <MotifErrorMessage
                aria-live="assertive"
                role="alert"
                id="aria-error-example"
              >
                {skuLongDescriptionError ? skuLongDescriptionError.message : ""}
              </MotifErrorMessage>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row heading costing-label">
        <div className="motif-col-lg-12">
          <div className="title">Costing</div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {COST_CATEGORY}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={sortOptions(CostCategoryTypeOptions)}
                    value={costCategory}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "costCategory",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={COST_CATEGORY_PLACEHOLDER}
                    multiple={false}
                    placeholder={COST_CATEGORY_PLACEHOLDER}
                    disabled={
                      disableAll ||
                      !editableFields.includes("costCategory") ||
                      chargingIncrement === "onetime" ||
                      chargingIncrement === "autotransact"
                    }
                  />
                  {costCategoryError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {costCategoryError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {COST_INTERVAL}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={sortOptions(ChargingIncrementOptions)}
                    value={chargingIncrement}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "chargingIncrement",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={COST_INTERVAL_PLACEHOLDER}
                    multiple={false}
                    placeholder={COST_INTERVAL_PLACEHOLDER}
                    disabled={
                      disableAll ||
                      !editableFields.includes("chargingIncrement")
                    }
                  />
                  {chargingIncrementError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {chargingIncrementError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {RETURNABLE}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={[
                      { label: "Yes", value: "1" },
                      { label: "No", value: "0" },
                    ]}
                    value={returnable}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "returnable",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={RETURNABLE_PLACEHOLDER}
                    multiple={false}
                    placeholder={RETURNABLE_PLACEHOLDER}
                    disabled={
                      disableAll ||
                      !editableFields.includes("returnable") ||
                      chargingIncrement === "autotransact"
                    }
                  />
                  {returnableError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {returnableError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {COST_MACRO_CATEGORY}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <MultiSelect
                    options={CostMacroCategoryOptions}
                    value={costMacroCategory}
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "costMacroCategory",
                          value: selectedOption,
                        },
                      })
                    }
                    placeholder={COST_MACRO_CATEGORY_PLACEHOLDER}
                    hasSelectAll={true}
                    selectAllLabel="Select all"
                    selectAllValue="all"
                    theme="ch-light"
                    isDisabled={disableAll}
                  />
                  {costMacroCategoryError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {costMacroCategoryError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {MINIMUM_SELECTABLE_INCREMENT}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <InputBox
                    ariaLabel=""
                    label=""
                    onChange={handleChange}
                    name={"minimumSelectableIncrement"}
                    value={
                      chargingIncrement === "autotransact" &&
                      costCategory === "Variable"
                        ? "1"
                        : minimumSelectableIncrement
                    }
                    placeholder={MINIMUM_SELECTABLE_INCREMENT}
                    error={minimumSelectableIncrementError}
                    readonly={
                      disableAll ||
                      !editableFields.includes("minimumSelectableIncrement") ||
                      chargingIncrement === "onetime" ||
                      chargingIncrement === "autotransact"
                    }
                    hideClearButton={true}
                  />
                  {minimumSelectableIncrementError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {minimumSelectableIncrementError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {COST}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <InputBox
                    name={"cost"}
                    ariaLabel=""
                    label={COST}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={formatUSDWithCommas(cost)}
                    hideClearButton={true}
                    error={costError}
                    placeholder={""}
                    prefix="$USD"
                    readonly={disableAll || !editableFields.includes("cost")}
                  />
                  {costError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {costError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg hide">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">{SKU_RELATION}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={skuRelationOption ?? []}
                    value={skuRelation}
                    onChange={(selectedOption) => {
                      handleChangeSku({
                        target: {
                          name: "skuRelation",
                          value: selectedOption,
                        },
                      });
                    }}
                    searchPlaceholder={SKU_RELATION_PLACEHOLDER}
                    multiple={true}
                    placeholder={SKU_RELATION_PLACEHOLDER}
                    disabled={
                      disableAll ||
                      !editableFields.includes("skuRelation") ||
                      getSKUData.isChild ||
                      chargingIncrement === "autotransact"
                    }
                  />
                  {skuRelationError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {skuRelationError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {AUTO_PROVISION}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={[
                      { label: "Yes", value: "1" },
                      { label: "No", value: "0" },
                    ]}
                    value={autoProvision}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "autoProvision",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={AUTO_PROVISION_PLACEHOLDER}
                    multiple={false}
                    placeholder={AUTO_PROVISION_PLACEHOLDER}
                    disabled={
                      disableAll ||
                      !editableFields.includes("autoProvision") ||
                      chargingIncrement === "autotransact"
                    }
                  />
                  {autoProvisionError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {autoProvisionError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {BILLING_TYPE_STATUS}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={sortOptions(BillingTypeOptions) || []}
                    value={billingType}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "billingType",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={BILLING_TYPE_STATUS}
                    multiple={false}
                    placeholder={BILLING_TYPE_STATUS}
                    disabled={
                      disableAll || !editableFields.includes("billingType")
                    }
                  />
                  {billingTypeError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {billingTypeError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item">
              <div className="label">
                {COST_METRIC}
                <span className="required">*</span>
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={sortOptions(CostMetricOptions) || []}
                    value={costMetric}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "costMetric",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={COST_METRIC}
                    multiple={false}
                    placeholder={COST_METRIC}
                    disabled={
                      disableAll || !editableFields.includes("costMetric")
                    }
                  />
                  {costMetricError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {costMetricError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">{NSR}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <InputBox
                    name={"CostMetricNSR"}
                    ariaLabel=""
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={formatUSDWithCommas(CostMetricNSR)}
                    error={CostMetricNSRError}
                    hideClearButton={true}
                    prefix="$USD"
                    placeholder={""}
                    readonly={
                      disableAll || !editableFields.includes("CostMetricNSR")
                    }
                  />
                  {CostMetricNSRError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {CostMetricNSRError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item">
              <div className="label">{INDEXATION}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField indexation-input-field">
                  <InputBox
                    name={"Indexation"}
                    ariaLabel=""
                    onChange={handleChange}
                    value={Indexation}
                    suffix={Indexation ? "%" : ""}
                    hideClearButton={true}
                    placeholder={INDEXATION_PLACEHOLDER}
                    readonly={disableAll}
                    onBlur={handleBlur}
                  />
                  {IndexationError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {IndexationError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div
              className={`motif-col-lg-4 form-item ${
                commercialStatus === "sku_active" ? "" : "hide"
              }`}
            >
              <div className="label">
                {COMMERCIAL_STATUS}
                <span className="required">*</span>
              </div>
            </div>
            <div
              className={`motif-col-lg-8 form-item ${
                commercialStatus === "sku_active" ? "" : "hide"
              }`}
            >
              <div className="value">
                <div className="inputField">
                  <SelectBox
                    options={sortOptions(CommercialStatusOptions) || []}
                    value={commercialStatus}
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange={(selectedOption: any) =>
                      handleChange({
                        target: {
                          name: "commercialStatus",
                          value: selectedOption,
                        },
                      })
                    }
                    searchPlaceholder={COMMERCIAL_PLACEHOLDER}
                    multiple={false}
                    placeholder={COMMERCIAL_PLACEHOLDER}
                    disabled={disableAll}
                  />
                  {commercialStatusError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      {commercialStatusError.message}
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {disableAll && (
        <CostUpdateRequest
          formFields={formFields}
          skuResponse={getSKUData}
          UpdateCostId={getSKUData?.UpdateCostId}
          disableCostUpdate={disableCostUpdate}
          hideCostUpdate={hideCostUpdate}
        />
      )}

      <div className="motif-row heading">
        <div className=" motif-col-lg-12">
          <div className="title">{ORDER_ACKNOWLEDGEMENT}</div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item label-item">
              <div className="label">{GLOBAL_RISK_MANAGER}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <UserSearchSelect
                    proxyOwners={globalRiskMng}
                    name={"globalRiskManager"}
                    setUserSearchSelect={setGlobalRiskMng}
                    readOnly={disableAll || false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item label-item">
              <div className="label">{LOCAL_RISK_MANAGER}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <UserSearchSelect
                    name={"localRiskManager"}
                    proxyOwners={localRiskMng}
                    setUserSearchSelect={setLocalRiskMng}
                    readOnly={disableAll || false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item label-item">
              <div className="label">{PRODUCT_APPROVER}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <UserSearchSelect
                    proxyOwners={productApproverList}
                    setUserSearchSelect={setProductApproverList}
                    readOnly={disableAll || false}
                    name="productApprover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg">
          <div className="motif-row right-content">
            <div className="motif-col-lg-4 form-item label-item">
              <div className="label">
                {PROVISIONING_TEAM}
                {isNotAutoProvisioned && <span className="required">*</span>}
              </div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <UserSearchSelect
                    proxyOwners={deploymentApproverList}
                    setUserSearchSelect={setDeploymentApproverList}
                    readOnly={disableAll || false}
                    callBack={handleDeploymentApproverChange}
                    name="deploymentApprover"
                  />
                  {deploymentApproverError.isError ? (
                    <MotifErrorMessage
                      aria-live="assertive"
                      role="alert"
                      id="aria-error-primaryList"
                    >
                      You must enter at least one email for the Provisioning
                      Team
                    </MotifErrorMessage>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="motif-row form-item-row double-row">
        <div className="motif-col-lg">
          <div className="motif-row">
            <div className="motif-col-lg-4 form-item label-item">
              <div className="label">{CONSUMPTION_MANAGER}</div>
            </div>
            <div className="motif-col-lg-8 form-item">
              <div className="value">
                <div className="inputField">
                  <UserSearchSelect
                    proxyOwners={consumptionManagerList}
                    setUserSearchSelect={setConsumptionManagerList}
                    name={"consumptionManager"}
                    readOnly={disableAll || false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="motif-col-lg" />
      </div>
    </div>
  );
}
